module.exports = __webpack_public_path__ + "img/cir-exm1.5f2d9a0f.png";